import { AbstractControl, ValidationErrors } from '@angular/forms';

export function PartnerIdDifferentValidator(control: AbstractControl): ValidationErrors | null {
  if (!control.parent) {
    return null;
  }

  const partnerIdNumber = control.value;
  const userIdNumber = control.parent.get('idNumber')?.value;
  const maritalStatus = control.parent.get('maritalStatus')?.value;

  if ((maritalStatus === 'married' || maritalStatus === 'cohabiting') && partnerIdNumber && userIdNumber) {
    if (partnerIdNumber.toString().trim().toLowerCase() === userIdNumber.toString().trim().toLowerCase()) {
      return {
        partnerIdSameAsUser: true
      };
    }
  }

  return null;
}

